<script>
  import Featured from "./Marketing Components/Featured.svelte";
  import Following from "./Marketing Components/Following.svelte";
  import PrimaryNav from "./PrimaryNav.svelte";
  import Favorites from "./Marketing Components/Favorites.svelte";
  import Shared from "./Marketing Components/Shared.svelte";
  import Private from "./Marketing Components/Private.svelte";
  import Waitlist from "./Marketing Components/Waitlist.svelte";
  import {navStatus, modalStatus} from "./AppState/Stores.js";
  import ModalDisplay from "./ModalDisplay.svelte";
  import MediaCreator from "./Marketing Components/MediaCreator.svelte";
  import MemoryCreator from "./Marketing Components/MemoryCreator.svelte";
  import CollectionCreator from "./Marketing Components/CollectionCreator.svelte";

  import {afterUpdate} from "svelte";
  import {beforeUpdate} from "svelte";
  let updateComparator = null
  beforeUpdate(() => {
    updateComparator = navStatus
  })
  afterUpdate(() => {
    if (updateComparator != navStatus) {
      document.getElementById('dc').scrollTo(0,0)
    }
  })

</script>

<main>
  <globalLayoutContainer>

    <logo>
      <img src="images/PawsLogo.jpg" height="60"/>
      <p>Look at these paws!</p>
    </logo>

    <right/>

    <search>
      <input type="text" placeholder="Search...">
      <button on:click="{ () => {
        $navStatus = 'waitlist'
        }
       }"
      >
        Sign In
      </button>
    </search>

    <action>
      <PrimaryNav/>
    </action>

    <dynamicContent id="dc">
      {#if $navStatus=== 'waitlist'}            <Waitlist/>

      {:else if $navStatus=== "featured"}       <Featured/>
      {:else if $navStatus=== "following"}      <Following/>
      {:else if $navStatus=== "favorites"}      <Favorites/>
      {:else if $navStatus=== "shared"}         <Shared/>
      {:else if $navStatus=== "private"}        <Private/>
      <!--{:else if $navStatus=== "media"}          <MediaCreator/>-->
      <!--{:else if $navStatus=== "memories"}       <MemoryCreator/>-->
      <!--{:else if $navStatus=== "collection"}     <CollectionCreator/>-->

      {:else }                                  <h2>Bad Navigation</h2>
      {/if}
    </dynamicContent>

    <footer>
      <dividerLine/>
      <p>my profile</p>
      <p>privacy and social settings</p>
      <p>about</p>
    </footer>
  </globalLayoutContainer>
</main>

<modal class:active="{$modalStatus === 'on'}">
  <ModalDisplay/>
</modal>


<style>
  modal {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,1);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;

    z-index: 101;
  }
  .active {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.2s;
  }
  modal h1 {
    color: white;
  }

  main {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    z-index: 100;
  }

  globalLayoutContainer {
    min-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    display: grid;
    grid-template-columns: 225px minmax(340px, 60%) 1fr;
    grid-template-rows: 80px 4fr 1fr;
    grid-template-areas:
			  "logo search right"
			  "action dynamicContent dynamicContent"
			  "footer dynamicContent dynamicContent"
  ;
    justify-items: stretch;
    align-items: stretch;
  }

  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 80%;
    height: 1px;
    margin-top: 50px;
    margin-bottom:50px;
  }

	logo {
    grid-area: logo;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid slategrey;
	}

	search {
    grid-area: search;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-self: center;
    align-items: center;
    border-bottom: 1px solid slategrey;
  }

  right {
    border-bottom: 1px solid slategrey;
    height: 100%;
  }

	action {
    grid-area: action;
    margin-top: 1px;
    padding-left: 20px;
    padding-left: 8px;
    /*background-color: rgb(250,250,250);*/
	}

    sectionHeader {
      margin-left: 18px;
    }

	footer {
		grid-area: footer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 8px;
  }

  dynamicContent {
		grid-area: dynamicContent;
    margin-left: 25px;
    margin-top: 5px;
    display: block;
    overflow-y: auto;
    scrollbar-width:none;
  }

  dynamicContent::-webkit-scrollbar {
    display: none;
  }

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
